// Rohini 03/20/2023 3225736869 fixed table alignmnents issue.
// T Santosh Kumar 24/03/2023 3225736869 Added the Icon
// Akhila 04/19/2023 3225736869  table reusable in account summary
// Akhila 06/05/2023 3225736869 bug fix preppropulation issue in account summary
// Ravi 06/22/2023 3225736869 fixed submit issue
// Suresh Peddavoora 06/27/2023 3225736869 fixed table alignments
// Guru Prasad 10/07/2023 5152729171 fixed table alignments
// Gireesh 13/10/2023 5155351118 fixed table rows drag and drop issue
// uday 16/10/2023 5152729171 add condtion classname table alignments issues
// Sohel 07/12/2023 5155351118 Fixed Client Management Reset Issue
import React, {useEffect, useState, useMemo} from 'react';
import {Button, Grid, makeStyles, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {defaultRows, tablePageRows} from '../../../constants/ReusableTablePagination';
import reusableInputStyles from '../../../components/InputStyles';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {useDispatch, useSelector} from 'react-redux';
import DialogBox from '../../../components/DialogBox';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {
  getContactsDetails,
  getEditContactDetails,
  postContactsListData,
  resetEditTableData,
  fetchContactData,
  resetClientInfo,
} from '../../../redux/reducers/clientMangement/Organizaation';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import ContactForm from './ContactForm';
import PhoneForm from './PhoneForm';
import AddressForm from './AddressForm';
import {MTableBody, MTableBodyRow} from 'material-table';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
// import PhoneAndroidOutlinedIcon from "@material-ui/icons/PhoneAndroidOutlined";
// import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import AddIcon from '@material-ui/icons/AddOutlined';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

const useStyles = makeStyles({
  letterTable: {
    '& .MuiTableRow-root': {
      color: 'inherit',
      display: 'flex',
      outline: 0,
      verticalAlign: 'middle',
    },
    '& .MuiTableBody-root': {
      display: 'inherit',
      textAlign: 'center',
    },
    // "& .MuiTableCell-body": {
    //   paddingLeft: "20px !important",
    // },
    // "& .MuiTableCell-root": {
    //   width: "100px",
    // },

    '& .MuiTableSortLabel-root > div': {
      fontSize: '0.790rem !important',
      fontWeight: 'bold !important',
    },
  },
  link: {
    color: '#320469',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'articulat-cf sans-serif ',
  },
});

export default function searchTable({
  orgType,
  id,
  AccountSummary,
  clientInfoData,
  clientNumber,
  organizationAccess,
}) {
  const {
    contacTableData,
    errorMsg,
    successMsg,
    contactsData,
    editContactData,
  } = useSelector(({organization}) => organization);
  const classes = reusableInputStyles();
  const classes1 = useStyles();
  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useDispatch();
  const [rows, setRows] = useState(defaultRows);
  const [open, setOpen] = useState(false);
  const [openPhone, setOpenPhone] = useState(false);
  const [openAddress, setOpenAddress] = useState(false);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const getApiData = useMemo(() => {
    if (contacTableData && contacTableData.length > 0) {
      return contacTableData.map((item) => ({...item}))?.sort((a, b) => a.sequenceNo - b.sequenceNo);
    }
    return [];
  }, [contacTableData]);
  const handleClose = () => {
    setOpen(false);
    dispatch(resetEditTableData());
  };
  const handleClosed = () => {
    setOpenPhone(false);
    dispatch(resetEditTableData());
  };
  const handleCloseAddress = () => {
    setOpenAddress(false);
    dispatch(resetEditTableData());
  };
  useEffect(() => {
    if (AccountSummary && clientNumber) {
      dispatch(fetchContactData(clientNumber));
    }
  }, [AccountSummary, clientNumber]);
  useEffect(() => {
    if (getApiData?.length > 0) {
      const data = [...getApiData];
      data?.sort((a, b) => a['sequenceNo'] - b['sequenceNo']);
      const newData = data.map((item, i) => ({...item, sequenceNo: i + 1}));
      setSelectedRows(newData);
    } else if (contactsData?.length > 0) {
      const data = [...contactsData];
      data?.sort((a, b) => a['sequenceNo'] - b['sequenceNo']);
      const newData = data.map((item, i) => ({...item, sequenceNo: i + 1}));
      setSelectedRows(newData);
    } else {
      setSelectedRows([])
    }
  }, [getApiData, contactsData]);

  useEffect(() => {
    if (successMsg) {
      dispatch(getContactsDetails(id, orgType));
      handleClose();
      dispatch(resetClientInfo());
    }
  }, [successMsg]);

  const columns = [
    {
      title: 'Seq No',
      field: 'sequenceNo',
      // headerStyle: { width: 80, textAlign: "left" },
      // cellStyle: { width: 80, textAlign: "left" },
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        if (selectedRows.length > 0) {
          selectedRows[rowData?.tableData?.id].sequenceNo = rowSeqNo;
        }
        return (
          <div
            style={{
              // maxWidth: 100,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              paddingLeft: '20px',
            }}
          >
            {rowSeqNo}
          </div>
        );
      },
    },
    {
      title: 'Contact Type',
      field: 'contactType',
      // cellStyle: { width: 154, textAlign: "left" },
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 130,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              // paddingLeft: "10px",
            }}
          >
            {rowData?.contactType ? rowData?.contactType : ''}
          </div>
        </>
      ),
    },
    {
      title: 'First Name',
      field: 'firstName',
      // cellStyle: { width: 120, textAlign: "left" },
      // headerStyle: { width: 100, textAlign: "left" },
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 95,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              paddingLeft: '-3px',
            }}
          >
            {rowData?.firstName ? rowData?.firstName : ''}
          </div>
        </>
      ),
    },
    {
      title: 'Last Name',
      field: 'lastName',
      // cellStyle: { width: 95, textAlign: "left" },
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 100,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              paddingLeft: '4px',
            }}
          >
            {rowData?.lastName ? rowData?.lastName : ''}
          </div>
        </>
      ),
    },
    {
      title: 'Title',
      field: 'title',
      // cellStyle: { width: 100, textAlign: "left" },
      // headerStyle: { width: 100, textAlign: "left" },

      render: (rowData) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              // marginLeft: "-10px",
              textAlign: 'left',
              overflow: 'ellipsis',
              // width: "100px !important",
            }}
          >
            {rowData?.title ? rowData?.title : ''}
          </div>
        </>
      ),
    },
    {
      title: 'Email Address',
      field: 'emailAddress',
      // headerStyle: { width: 120, textAlign: "left" },

      // cellStyle: { width: 120, textAlign: "left"  },
      render: (rowData) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              // marginLeft: "-25px",
              maxWidth: '200px',
            }}
          >
            {rowData?.emailAddress ? rowData?.emailAddress : ''}
          </div>
        </>
      ),
    },
    {
      title: 'Email Opt In',
      field: 'emailOptIn',
      // cellStyle: { width: 140, textAlign: "left" },
    },
    {
      title: 'Is Active',
      field: 'isActive',
      // cellStyle: { width: 140, textAlign: "left" },
      render: (rowData) => {
        return rowData?.isActive === 'Y' ? 'Yes' : rowData?.isActive === 'N' ? 'No' : '';
      },
    },
    {
      title: 'Phone Details',
      // cellStyle: { width: 145, textAlign: "left" },
      // field: "emailOptIn",
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            dispatch(getEditContactDetails(rowData?.organizationContactId));
            setOpenPhone(true);
          }}
        >
          View
        </span>
      ),
    },
    {
      title: 'Address Details',
      // cellStyle: { width: 150, textAlign: "left" },
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={(event) => {
            dispatch(getEditContactDetails(rowData?.organizationContactId));
            setOpenAddress(true);
          }}
        >
          View
        </span>
      ),
    },
  ];

  const onDragEnd = (result) => {
    const {destination, source} = result;
    if (!destination) {
      return;
    }
    if (source.index !== destination.index) {
      const copyRows = [...selectedRows];
      const temp = selectedRows[source.index];
      copyRows.splice(source.index, 1);
      copyRows.splice(destination.index, 0, temp);
      setSelectedRows(copyRows);
    }
  };
  return (
    <div className="mt-3">
      <DialogBox
        open={openPhone}
        dialogClose={handleClosed}
        hideFooter={true}
        maxWidth={'lg'}
        title={'Phone Details'}
      >
        <PhoneForm handleClose={handleClose} id={id} type={orgType} selectedRows={selectedRows} />
      </DialogBox>
      <DialogBox
        open={openAddress}
        dialogClose={handleCloseAddress}
        hideFooter={true}
        maxWidth={'lg'}
        title={'Address Details'}
      >
        <AddressForm handleClose={handleClose} id={id} type={orgType} selectedRows={selectedRows} />
      </DialogBox>
      <DialogBox
        open={open}
        dialogClose={handleClose}
        hideFooter={true}
        maxWidth={'lg'}
        title={
          editContactData?.organizationContactId ? 'Edit Contact Details' : `Add Contact Details`
        }
      >
        <ContactForm
          handleClose={handleClose}
          id={id}
          orgType={orgType}
          selectedRows={selectedRows}
        />
      </DialogBox>
      <Grid item xs={12} className="">
        <div
          className={AccountSummary ? `mb-4 global-field-table custom-table ${classes1.letterTable} drag-and-drop-table custom-map-sec new-standard-textfields`:
          `mb-4 global-field-table custom-table ${classes1.letterTable} drag-and-drop-table custom-map-sec drawdrag-table   new-standard-textfields `}
        >
          <GuiTable
            title={`Contacts Details`}
            columns={columns}
            icons={tableIcons}
            data={selectedRows.length > 0 ? selectedRows?.map((item) => ({...item})) : getApiData}
            options={{
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'right',
              showTextRowsSelected: false,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={
              !AccountSummary && [
                {
                  icon: () => (
                    <>
                      <Button
                        type="button"
                        variant="outlined"
                        className={`search-btn`}
                        startIcon={<AddIcon />}
                        disabled={!organizationAccess?.edit}
                      >
                        Add Contact Details
                      </Button>
                    </>
                  ),
                  disabled: !organizationAccess?.edit,
                  isFreeAction: true,
                  onClick: (event) => {
                    setOpen(true);
                  },
                },
                {
                  icon: () => <EditOutlinedIcon />,
                  tooltip: 'Edit',
                  disabled: !organizationAccess?.edit,
                  onClick: (event, rowData) => {
                    dispatch(getEditContactDetails(rowData?.organizationContactId));
                    setOpen(true);
                  },
                },
              ]
            }
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
              Body: (props) => (
                <div>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId={'singleColumnDroppableAreaThusStaticInput'}>
                      {(provided) => (
                        <div ref={provided.innerRef}>
                          <MTableBody {...props} />
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              ),
              Row: (props) => (
                <Draggable
                  draggableId={props.data.tableData.id.toString()}
                  index={props.data.tableData.id}
                >
                  {(provided) => (
                    <div
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      ref={provided.innerRef}
                    >
                      <MTableBodyRow {...props} />
                    </div>
                  )}
                </Draggable>
              ),
            }}
          />
        </div>
      </Grid>
      <div className="button-spacing-mb  new-standard-textfields">
        <Button
          variant="outlined"
          className={`reset-btn mr-1 ${classes.buttonRoot}`}
          hidden={AccountSummary}
          onClick={() => {
            const data = [...contactsData];
            data?.sort((a, b) => a['sequenceNo'] - b['sequenceNo']);
            const newData = data.map((item, i) => ({...item, sequenceNo: i + 1}));
            setSelectedRows(newData);
          }}
        >
          Reset
        </Button>
        <Button
          variant="outlined"
          type="button"
          hidden={AccountSummary}
          disabled={!organizationAccess?.edit || enabledSubmission}
          className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
          onClick={() => {
            // const data = selectedRows.map((item) => ({
            //   emailAddress: item.emailAddress,
            //   emailOptIn: item.emailOptIn,
            //   firstName: item.firstName,
            //   lastName: item.lastName,
            //   organizationContactId: item.organizationContactId,
            //   organizationId: item.organizationId,
            //   organizationType: item.organizationType,
            //   sequenceNo: item.sequenceNo,
            // }));
            dispatch(submissionStart());
            dispatch(postContactsListData({organizationContactsListRequest: selectedRows}));
          }}
        >
          Save
        </Button>
      </div>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
}
